import { createContext, useContext, useReducer } from "react";

const PaymentModalContext = createContext();

const modalReducer = (state, action) => {
    switch (action.type) {
        case "OPEN":
            return true;
        case "CLOSE":
            return false;
        default:
            return state;
    }
};

export const PaymentModalProvider = ({ children }) => {
    const [isOpen, dispatch] = useReducer(modalReducer, false);

    return <PaymentModalContext.Provider value={{ isOpen, dispatch }}>{children}</PaymentModalContext.Provider>;
};

export const usePaymentModal = () => useContext(PaymentModalContext);
